// tslint:disable: arrow-return-shorthand
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Context } from '../../AppContext';
import {
  addedMinutesForCurrentDate,
  convertTime12to24,
  defaultPickupTime,
  isTimeGreater
} from '../../utils/timeUtils';
import './Slides.css';
const dayjs = require('dayjs');

const cardWidthForShowingSpaceSeparatedInfo = 180;
export const buttonWidth = 44;
const cardWidthDuringOverflow = 143;
const filterCabCardWidth = 940;

export const isLeftScrollable = (ref: any) => {
  if (ref?.current?.scrollLeft > 0) {
    return true;
  }
  return false;
};

export const isRightScrollable = (ref: any) => {
  if (
    Math.ceil(ref?.current?.scrollLeft + ref?.current?.offsetWidth) <
    ref?.current?.scrollWidth
  ) {
    return true;
  }
  return false;
};

const Slides = ({
  slideElements,
  selectedElement,
  sourceCityCode,
  destinationCityCode
}: {
  slideElements: any;
  selectedElement: any;
  sourceCityCode: string;
  destinationCityCode: string;
}) => {
  const { trackTemplateEvent, omniUrlArgs } = useContext(Context);
  const navRefOuter = useRef(null);
  const navRef = useRef(null);
  const [leftScrollable, setLeftScrollable] = useState<boolean>(true);
  const [rightScrollable, setRightScrollable] = useState<boolean>(true);

  useEffect(() => {
    setLeftScrollable(isLeftScrollable(navRef));
    setRightScrollable(isRightScrollable(navRef));
  }, []);

  const scrollHorizontalLeft = () => {
    // @ts-ignore
    if (navRef?.current?.scrollLeft !== undefined) {
      // @ts-ignore
      navRef.current.scrollLeft -= cardWidthDuringOverflow * 2;
    }
    setLeftScrollable(isLeftScrollable(navRef));
    setRightScrollable(isRightScrollable(navRef));
  };

  const scrollHorizontalRight = () => {
    // @ts-ignore
    if (navRef?.current?.scrollLeft !== undefined) {
      // @ts-ignore
      navRef.current.scrollLeft += cardWidthDuringOverflow * 2;
    }
    setLeftScrollable(isLeftScrollable(navRef));
    setRightScrollable(isRightScrollable(navRef));
  };

  const setCardWidth = () => {
    return doCardsOverFlow()
      ? {
          minWidth: cardWidthDuringOverflow,
          maxWidth: cardWidthDuringOverflow,
          width: cardWidthDuringOverflow
        }
      : { width: '100%', minWidth: 'none', maxWidth: 'none' };
  };

  const doCardsOverFlow = () => {
    // default value set as lowest width as in review page
    let width = filterCabCardWidth;
    // @ts-ignore
    if (navRefOuter?.current?.scrollWidth) {
      // @ts-ignore
      width = navRefOuter?.current?.scrollWidth;
    }
    return (
      width - buttonWidth * 2 <
      (slideElements?.length || 0) * cardWidthDuringOverflow
    );
  };

  const getWidthOfCard = () => {
    // default value set as lowest width as in review page
    let width = filterCabCardWidth;
    // @ts-ignore
    if (navRefOuter?.current?.scrollWidth) {
      // @ts-ignore
      width = navRefOuter?.current?.scrollWidth;
    }
    return width / (slideElements?.length || 1);
  };

  interface ButtonComponentProps {
    clickAction: () => void;
    buttonClassName: string;
  }
  const ButtonComponent = ({
    clickAction,
    buttonClassName = ''
  }: ButtonComponentProps) => {
    return (
      <div
        className="hourlyRentalsSlideButton flexWrap alignCenter  makeFlex"
        onClick={() => clickAction()}
      >
        <span className={buttonClassName}>{}</span>
      </div>
    );
  };

  const cardWidth = getWidthOfCard();
  return (
    <>
      {slideElements && slideElements?.length > 0 ? (
        <div
          ref={navRefOuter}
          className={'hourlyRentalsSlide fullWidth appendBottom20'}
        >
          <div
            style={{ width: filterCabCardWidth }}
            className="sliderBorder  makeFlex fullWidth "
          >
            {
              <ButtonComponent
                clickAction={scrollHorizontalLeft}
                buttonClassName={`left hourlyRentalsSlideArrow leftSlideArrow ${
                  leftScrollable ? '' : 'inactive'
                }`}
              />
            }
            <div
              className={'slider makeFlex fullWidth  hideScrollBar '}
              ref={navRef}
            >
              {slideElements.map((slideElement, idx) => {
                const isSelectedPackage = slideElement === selectedElement;
                return (
                  <div
                    key={'date_slide_' + idx}
                    onClick={() => {
                      if (isSelectedPackage) {
                        return;
                      } else {
                        const todaysDate = new Date();

                        const selectedDateString = dayjs(todaysDate)
                          .add(idx, 'day')
                          .format('DD-MM-YYYY');
                        let pickupTime = convertTime12to24(defaultPickupTime);

                        if (idx == 0) {
                          // idx==0->same date
                          const currentTime = dayjs(todaysDate).format('HH:mm');
                          // if current time is greater than selected pick up time then change pickup time
                          if (isTimeGreater(currentTime, pickupTime)) {
                            pickupTime = dayjs(todaysDate)
                              .add(addedMinutesForCurrentDate, 'minute')
                              .format('HH:mm');
                          }
                        }
                        trackTemplateEvent(
                          `Cab_SEO_Isomorph_Time_Card_Click_${idx}`
                        );

                        window.location = Object(
                          `https://cabs.makemytrip.com/cabsListing?fromCity=${sourceCityCode}&toCity=${destinationCityCode}&tripType=OW&departDate=${selectedDateString}&pickupTime=${pickupTime}&${omniUrlArgs}`
                        );
                      }
                    }}
                    style={{
                      ...setCardWidth() // setting card width based on number of cards/ whether there is overflow or not
                    }}
                    className={` slides makeFlex algnCenter   ${
                      isSelectedPackage
                        ? 'deepskyBlueText active cursorInitial'
                        : 'hourlyRentalsSlideUnselectedTextColor'
                    }`}
                  >
                    <div
                      style={{
                        display:
                          cardWidth > cardWidthForShowingSpaceSeparatedInfo
                            ? 'flex'
                            : 'block'
                      }}
                      className="vertlCenter horizontalCenter"
                    >
                      <div className="hourlyRentalsSlideTime latoRegular font14 latoBold ">
                        {slideElement}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {
              <ButtonComponent
                clickAction={scrollHorizontalRight}
                buttonClassName={`right hourlyRentalsSlideArrow rightSlideArrow ${
                  rightScrollable ? '' : 'inactive'
                }`}
              />
            }
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Slides;
